export interface ISetNewPasswordRequest {

    ResetPasswordID: string;
    NewPassword: string;

}

export class SetNewPasswordRequest implements ISetNewPasswordRequest {

    public ResetPasswordID: string;
    public NewPassword: string;

}